import { render } from "./AIFlyoutDrawer.vue?vue&type=template&id=54c4fc8e&scoped=true"
import script from "./AIFlyoutDrawer.vue?vue&type=script&lang=js"
export * from "./AIFlyoutDrawer.vue?vue&type=script&lang=js"

import "./AIFlyoutDrawer.vue?vue&type=style&index=0&id=54c4fc8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c4fc8e"]])

export default __exports__